import { render, staticRenderFns } from "./AbandonOrder.vue?vue&type=template&id=1a46f8d7&scoped=true&"
import script from "./AbandonOrder.vue?vue&type=script&lang=js&"
export * from "./AbandonOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a46f8d7",
  null
  
)

export default component.exports